import { render, staticRenderFns } from "./CoachNoteDetail.vue?vue&type=template&id=8de95994&scoped=true"
import script from "./CoachNoteDetail.vue?vue&type=script&lang=js"
export * from "./CoachNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./CoachNoteDetail.vue?vue&type=style&index=0&id=8de95994&prod&scoped=true&lang=css"
import style1 from "./CoachNoteDetail.vue?vue&type=style&index=1&id=8de95994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de95994",
  null
  
)

export default component.exports